export const sanitizeCpfOrName = (value: string): string => {
  if (!value) return '';

  const trimmed = value.trim();
  const cpfPattern = /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/;
  const onlyDigits = trimmed.replace(/\D/g, '');
  if (/^\d+$/.test(trimmed) || cpfPattern.test(trimmed)) {
    return onlyDigits;
  }
  return trimmed;
};
